export default "__VITE_ASSET__BAeXD_Vr__"